var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepicon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 450.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1263a9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step icon 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.2,61h15V76h-15Z",
    transform: "translate(0 -30.9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.1,61h15V76h-15Z",
    transform: "translate(0 -30.9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.6,106h15v15h-15Z",
    transform: "translate(0 -30.9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.5,106h15v15h-15Z",
    transform: "translate(0 -30.9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286,466.1h15v15H286Z",
    transform: "translate(0 -30.9)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M512,76.1H361V30.9H151V76.1H0V436H151v45H271V466H166V106H346v75h15V151.5H497V421H361V196H346V466.1H316v15h45v-45H512ZM15,421V151.4H45.9v-15H15V91.1H151v45.3H61v15h90V421ZM166,91.1V45.9H346V91H166Zm195,45.3V91.1H497v45.3Z",
    transform: "translate(0 -30.9)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196,286.1H316v15H196Z",
    transform: "translate(0 -30.9)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391,331h75v15H391Z",
    transform: "translate(0 -30.9)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196,331H316v15H196Z",
    transform: "translate(0 -30.9)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196,376H316v15H196Z",
    transform: "translate(0 -30.9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196,421h15v15H196Z",
    transform: "translate(0 -30.9)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226,421h15v15H226Z",
    transform: "translate(0 -30.9)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391,376h15v15H391Z",
    transform: "translate(0 -30.9)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421,376h15v15H421Z",
    transform: "translate(0 -30.9)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.9,331h75v15h-75Z",
    transform: "translate(0 -30.9)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.9,376h15v15h-15Z",
    transform: "translate(0 -30.9)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.9,376h15v15h-15Z",
    transform: "translate(0 -30.9)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.4,225.9H79.7a7.4,7.4,0,1,1,0-14.8h30v-15H91V181H76v15.4a22.41,22.41,0,0,0,3.8,44.5h7.7c9.8,0,9.8,15,0,15H57.2V271H76v15H91V270.6c26.7-4.7,23.7-44.7-3.6-44.7Z",
    transform: "translate(0 -30.9)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.9,181h-7.6a7.4,7.4,0,1,1,0-14.8h30v-15H263.5V136.1h-15v15.4a22.41,22.41,0,0,0,3.8,44.5H260c9.7,0,9.7,15,0,15H229.8v15.1h18.8v15h15V225.7c26.6-4.8,23.7-44.7-3.7-44.7Z",
    transform: "translate(0 -30.9)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.7,226h-7.6a7.4,7.4,0,1,1,0-14.8h30v-15H436.3V181.1h-15v15.4a22.41,22.41,0,0,0,3.8,44.5h7.7c9.8,0,9.6,15,0,15H402.6v15.1h18.8v15h15V270.7c26.6-4.8,23.7-44.7-3.7-44.7Z",
    transform: "translate(0 -30.9)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepicon2);
export default __webpack_public_path__ + "static/media/step icon 2.1b1fd7f991d8fa8c0839bbe28c49e703.svg";
export { ForwardRef as ReactComponent };